import { memo } from 'react';
import { Button } from 'rsuite';
import SavedFilters from '../../pages/IPA/RevisaoPrecos/Components/SavedFilters/SavedFilters';
import { useClusterStore } from '../../store/useClusterStore';
import { useStoreTypeStore } from '../../store/useStoreTypeStore';
import { FilterPlaceholder } from '../FilterPlaceholder';
import { InnerFilter } from '../FilterSection';
import { Layout } from '../Layout';
import { FamillyPill, ProductsPill, SegmentsPlaceholder } from './Components';
import MoreFiltersPill from './Components/MoreFiltersPill';
import MoreFiltersRender from './Components/MoreFiltersRender';
import styles from './NewFilterBox.module.scss';
import useNewFilterBox from './useNewFilterBox';

const MemoProductsPill = memo(ProductsPill);
const MemoFamillyPill = memo(FamillyPill);

const Checkpill = memo(InnerFilter);

const Placeholder = memo(FilterPlaceholder);

const { Section } = Layout;

const NewFilterBox = () => {
  const {
    data,
    values,
    cattegories,
    loading,
    isVisible,
    onSearch,
    onChange,
    onResponsibleChange,
    onClean,
    onCleanResponsible,
    onCleanAll,
    onOpen,
    onSelectAll,
  } = useNewFilterBox();
  const setSelectedClusters = useClusterStore(state => state.setSelectedClusters);
  const setSelectedStoreTypes = useStoreTypeStore(state => state.setSelectedStoreTypes);

  if (!isVisible) return null;

  const handleStoreTypeChange = (value: string[]) => {
    const selectedLabels = data.storeType?.filter(item => value.includes(item.value)).map(item => item.label) || [];
    setSelectedStoreTypes(selectedLabels);
    onChange('storeType', value);
  };

  return (
    <Section padded>
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <MemoProductsPill />
          <MemoFamillyPill />
          <Checkpill
            type="check"
            data={data.storeIds ?? []}
            value={values.storeIds}
            isLoading={loading.storeIds}
            onSearch={(query: string) => onSearch('storeIds', query)}
            onChange={(value: string[]) => onChange('storeIds', value)}
            onClose={() => onSearch('storeIds', '')}
            onClean={() => onClean('storeIds')}
            selectAll={{
              onSelectAll: checked => {
                onSelectAll('storeIds', checked);
              },
            }}
            placeholder={<Placeholder key="storeIds" dataKey="storeIds" placeholder="Lojas" />}
          />
          <Checkpill
            type="check"
            data={data.clusters ?? []}
            value={values.clusters}
            isLoading={loading.clusters}
            onSearch={(query: string) => onSearch('clusters', query)}
            onChange={(value: string[]) => {
              setSelectedClusters(value);
              onChange('clusters', value);
            }}
            onClose={() => onSearch('clusters', '')}
            onClean={() => onClean('clusters')}
            placeholder={<Placeholder key="clusters" dataKey="clusters" placeholder="Cluster" />}
          />

          <Checkpill
            type="check"
            data={data.storeType ?? []}
            value={values.storeType}
            isLoading={loading.storeType}
            onSearch={(query: string) => onSearch('storeType', query)}
            onChange={handleStoreTypeChange}
            onClose={() => onSearch('storeType', '')}
            onClean={() => {
              onClean('storeType');
              setSelectedStoreTypes([]);
            }}
            searchable={true}
            placeholder={<Placeholder key="storeType" dataKey="storeType" placeholder="Tipo de loja" />}
          />
          <Checkpill
            type="check"
            data={data.priceStatus ?? []}
            value={values.priceStatus}
            isLoading={loading.priceStatus}
            onChange={(value: string[]) => onChange('priceStatus', value)}
            onClose={() => onSearch('priceStatus', '')}
            onClean={() => onClean('priceStatus')}
            searchable={false}
            placeholder={<Placeholder key="priceStatus" dataKey="priceStatus" placeholder="Status de Preço" />}
            groupBy="role"
          />
          <Checkpill
            type="check"
            data={data.segmentos ?? []}
            value={values.segmentos}
            isLoading={loading.segmentos}
            onSearch={(query: string) => onSearch('segmentos', query)}
            onChange={(value: string[]) => onChange('segmentos', value)}
            onClose={() => onSearch('segmentos', '')}
            onClean={() => onClean('segmentos')}
            groupBy="role"
            searchable={false}
            placeholder={<Placeholder key="segmentos" dataKey="segmentos" placeholder="Segmentação" />}
          />
          <Checkpill
            type="check"
            data={data.productBrand ?? []}
            value={values.productBrand}
            isLoading={loading.productBrand}
            onSearch={(query: string) => onSearch('productBrand', query)}
            onChange={(value: string[]) => onChange('productBrand', value)}
            onClose={() => onSearch('productBrand', '')}
            onClean={() => onClean('productBrand')}
            placeholder={<Placeholder key="productBrand" dataKey="productBrand" placeholder="Marca" />}
          />
          <Checkpill
            type="check"
            data={data.supplier ?? []}
            value={values.supplier}
            isLoading={loading.supplier}
            onSearch={(query: string) => onSearch('supplier', query)}
            onChange={(value: string[]) => onChange('supplier', value)}
            onClose={() => onSearch('supplier', '')}
            onClean={() => onClean('supplier')}
            placeholder={<Placeholder key="segmentos" dataKey="segmentos" placeholder="Fornecedor" />}
          />
          <Checkpill
            type="select"
            data={data.responsible ?? []}
            value={values.responsible?.[0] ?? null}
            isLoading={loading.responsible}
            onSearch={(query: string) => onSearch('responsible', query)}
            onChange={onResponsibleChange}
            onClose={() => onSearch('responsible', '')}
            onClean={onCleanResponsible}
            searchable
            textSearch="Pesquisar"
            placeholder={<Placeholder key="responsible" dataKey="responsible" placeholder="Responsável" />}
          />
          <div className={styles['more-filters']}>
            <MoreFiltersPill />
            <Button className={styles['clear-button']} onClick={onCleanAll}>
              Limpar filtros
            </Button>
          </div>
        </div>

        <div className={styles.row}>
          {cattegories.map(({ value: key, level, name }) => (
            <Checkpill
              key={key}
              type="check"
              data={data[key] ?? []}
              value={values[key]}
              onSearch={(query: string) => onSearch(key, query)}
              onChange={(value: string[]) => onChange(key, value)}
              onOpen={() => onOpen(key)}
              onClose={() => onSearch(key, '')}
              onClean={() => onClean(key)}
              isLoading={loading.loadingCattegories}
              placeholder={<SegmentsPlaceholder level={level} placeholder={name} />}
            />
          ))}
          <SavedFilters className={styles.row} />
        </div>

        <MoreFiltersRender className={styles.row} />
      </div>
    </Section>
  );
};

export default memo(NewFilterBox);
